import { TotalProgressionBox } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/TotalProgressionBox";
import { StretchProgressCard } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/StretchProgressCard";
import {
  AltTransBusCoverage,
  AltTransStretchCoverage,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { Flex, Text } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";
import { BussesPassengersCounter } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/BussesPassengersCounter";
import { useMemo } from "react";
import { calculateTotalRequiredFromBusCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/common";
import { CAPACITY_PER_BUS } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/constants";

interface ProgressionBodyProps {
  showAllStretches: boolean;
  stretch: AltTransStretchCoverage | null;
  setStretch: (stretch: AltTransStretchCoverage | null) => void;
  allStretchCoverages: AltTransStretchCoverage[];
  totalCoverage: Nullish<AltTransBusCoverage>;
  peakPassengersRequiringTransport: Nullish<number>;
}

export const ProgressionBody = ({
  showAllStretches,
  stretch,
  setStretch,
  allStretchCoverages,
  totalCoverage,
  peakPassengersRequiringTransport,
}: ProgressionBodyProps) => {
  const displayedStretches = showAllStretches
    ? allStretchCoverages
    : allStretchCoverages.slice(0, 3);

  const sumBuses = useMemo(
    () =>
      totalCoverage ? calculateTotalRequiredFromBusCoverage(totalCoverage) : 0,
    [totalCoverage],
  );

  const passengers =
    peakPassengersRequiringTransport ?? sumBuses * CAPACITY_PER_BUS;

  return (
    <Flex direction="column" width="100%" gap="2">
      {totalCoverage && (
        <Flex alignItems="center" gap="1">
          <Text variant="xs" color="text.secondary">
            Maksimalt behov for totalt brudd:
          </Text>
          <BussesPassengersCounter
            vehicles={sumBuses}
            passengers={passengers}
            vehiclesFromMeasureCard={null}
          />
        </Flex>
      )}

      <Flex direction="row" gap="3" width="100%" alignItems="stretch">
        {totalCoverage && <TotalProgressionBox totalCoverage={totalCoverage} />}

        <Flex gap="1.5" minWidth="360px" flexGrow="1" direction="column">
          {displayedStretches.map((card, index) => (
            <StretchProgressCard
              // eslint-disable-next-line react/no-array-index-key -- No better alternative
              key={index}
              stretchCoverage={card}
              selectedStretch={stretch}
              setStretch={setStretch}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
